module.exports = __webpack_public_path__ + "r-v3/img/ml_08_00.030919db.jpg";